/**
 * get all the countries in all cats, for the init page
 * @param  {obj}    obj  the whole data
 * @return {array}       as below 
 */
/*
[
  {
    name: 'Canada',
    data: [12, 23, 23, ...]
  },
  {
    name: 'Mexico',
    data: [12, 23, 23, ...]
  },
]
*/
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.allCnts = allCnts;

function allCnts(obj) {
  var output = [];

  var hash = {};

  var _loop = function (cat) {
    var _loop3 = function (subCat) {
      if (subCat === 'total') return 'continue';

      var cnts = Object.keys(obj[cat][subCat]);
      if (cnts === 'Rest of the World') return 'continue';

      cnts.forEach(function (c) {
        if (hash[c] === undefined) hash[c] = [];
        obj[cat][subCat][c].forEach(function (val, index) {
          if (hash[c][index] === undefined) hash[c][index] = 0;
          hash[c][index] += val;
        });
      });
    };

    for (var subCat in obj[cat]) {
      var _ret3 = _loop3(subCat);

      if (_ret3 === 'continue') continue;
    }
  };

  for (var cat in obj) {
    _loop(cat);
  }

  var _loop2 = function (key) {

    var arr = [];
    hash[key].forEach(function (d) {
      arr.push(parseFloat(d.toFixed(1)));
    });

    output.push({
      name: key,
      data: arr
    });
  };

  for (var key in hash) {
    _loop2(key);
  }

  output.sort(function (a, b) {
    return b.data.reduce(function (b1, b2) {
      return b1 + b2;
    }) - a.data.reduce(function (a1, a2) {
      return a1 + a2;
    });
  });

  output = output.slice(0, 20);

  //console.dir(output)
  return output;
}
//# sourceMappingURL=data:application/json;base64,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